import loadable from '@loadable/component';
var AsyncTooltip = loadable(function () {
    return import('./Tooltip').then(function (_a) {
        var Tooltip = _a.Tooltip;
        return Tooltip;
    });
});
export default AsyncTooltip;
